import { View } from 'react-native'

import { env } from '@/src/config/env'
import { Typography } from '@/src/elements/text/Typography'

import { useDimensions } from '../hooks/useDimensions'

export const DevDimensions = () => {
  const breakpoints = useDimensions()
  const activeBreakpoint = Object.entries(breakpoints).find(
    ([key, value]) => key !== 'width' && key !== 'height' && value,
  )
  return env.EXPO_PUBLIC_APP_VARIANT === 'dev' ? (
    <View className="absolute top-0 items-center justify-center self-center rounded-ee-md rounded-es-md bg-white px-2">
      {/* oxlint-disable-next-line @shopify/jsx-no-hardcoded-content */}
      <Typography colors="primary">
        {activeBreakpoint ? activeBreakpoint[0] : ''} - {breakpoints.width}px
      </Typography>
    </View>
  ) : null
}
